import { render, staticRenderFns } from "./ReturnFlags.vue?vue&type=template&id=529d6726&scoped=true&"
import script from "./ReturnFlags.vue?vue&type=script&lang=js&"
export * from "./ReturnFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529d6726",
  null
  
)

export default component.exports